import {
	Avatar,
	Checkbox,
	IconButton,
	Paper,
	Typography,
	useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { RequestTable } from "../interfaces/Request";
import { MAIN_URL } from "../requester/requester";
import dateToHuman from "../utilities/date";
import ReceiptIcon from "@mui/icons-material/Receipt";

interface IProps {
	request: RequestTable;
	selectRequest?(item: RequestTable): void;
	selectedRequests: number[];
	setSelectedRequests: (value: number[]) => void;
}

const RequestCard = (props: IProps) => {
	return (
		<Paper
			className="flex gap-2 p-2 mb-5"
			// style={
			// 	props.selectedRequests.indexOf(props.request.id) !== -1
			// 		? {
			// 				backgroundColor: theme.palette.success.dark,
			// 		  }
			// 		: {}
			// }
		>
			<div className="flex items-center">
				<Checkbox
					checked={props.selectedRequests?.indexOf(props.request.id) !== -1}
					onChange={() => {
						var index: any = props.selectedRequests?.indexOf(props.request.id);

						var eventSelected: any = props.selectedRequests;
						if (index !== -1) {
							eventSelected?.splice(index, 1);
						} else {
							eventSelected?.push(props.request.id);
						}
						props.setSelectedRequests([...eventSelected]);
					}}
				/>
			</div>
			<div className="flex flex-col">
				<div className="flex justify-between">
					<Link to={`/candidate/${props.request.candidate.id}`}>
						<Typography>{props.request.candidate.full_name}</Typography>
					</Link>
					<Link to={`/manager/${props.request.manager.id}`}>
						<Avatar
							src={`${MAIN_URL}manager/avatar/${props.request.manager.avatar}`}
						/>
					</Link>
				</div>
				<Typography>{props.request.vacancy.name}</Typography>
				<Typography>
					{props.request.region}/{props.request.city}
				</Typography>
				<div className="flex justify-between">
					<Typography>{dateToHuman(props.request.creation_date)}</Typography>
					{props.request.candidate.id ? (
						<IconButton
							onClick={() => {
								if (props.selectRequest) props.selectRequest(props.request);
							}}
						>
							<ReceiptIcon />
						</IconButton>
					) : null}
				</div>
			</div>
		</Paper>
	);
};

export default RequestCard;
